import { render, staticRenderFns } from "./StaffAll.vue?vue&type=template&id=4b7b2091&"
import script from "./StaffAll.vue?vue&type=script&lang=ts&"
export * from "./StaffAll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports